import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { getNewsAndEvents, getNewsFeatured } from './thunk'

const initialState = {
  loading: {
    featured: true,
    newsAndEvent: true,
  },
  dataFeatured: {},
  dataNewsAndEvent: [],
}
const slice = createSlice({
  name: 'dashboard/news',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getNewsFeatured
    builder.addCase(getNewsFeatured.pending, (state, action) => {
      state.loading.featured = true
    })
    builder.addCase(getNewsFeatured.fulfilled, (state, action) => {
      state.dataFeatured = action.payload || []
      state.loading.featured = false
    })
    builder.addCase(getNewsFeatured.rejected, (state, action) => {
      state.dataFeatured = initialState.dataFeatured
      state.loading.featured = action.payload?.loading
    })
    //getNewsAndEvents
    builder.addCase(getNewsAndEvents.pending, (state, action) => {
      state.loading.newsAndEvent = true
    })
    builder.addCase(getNewsAndEvents.fulfilled, (state, action) => {
      state.dataNewsAndEvent = action.payload || []
      state.loading.newsAndEvent = false
    })
    builder.addCase(getNewsAndEvents.rejected, (state, action) => {
      state.dataNewsAndEvent = initialState.dataNewsAndEvent
      state.loading.newsAndEvent = action.payload.loading
    })
  },
})

//getNewsFeatured
export const getDataNewsFeatured = (state) => state[slice.name].dataFeatured
//getNewsAndEvents
export const getDataNewsAndEvent = (state) => state[slice.name].dataNewsAndEvent

export const selectLoadingNews = (type) => (state) =>
  state[slice.name].loading[type]

// export const { } = slice.actions

register(slice.name, slice.reducer)
